module.exports = __webpack_public_path__ + "static/008226-2e1eb753a37cf5a69685aa3002614bc8.jpg";